import Behaviour, { mix, DomEvents } from '@/core'
import { Route } from '@/core/router'
import SponDraw from 'spon-draw'
import resizer from 'spon-resize'
import $ from '@/core/dom'
import anime from 'animejs'
import domify from 'domify'
import { lock } from '@/core/utils'

/**
 *
 * @extends Behaviour
 * @class MobileMenu
 */
export default class Menu extends mix(Behaviour).with(DomEvents, Route) {
	/**
	 * @function constructor
	 * @param  {HTMLElement} el | the html element the behaviour is mounted on
	 * @return MobileMenu
	 */
	constructor(el) {
		super(el)

		this.$el = el

		/*
      This function must be called to trigger barba events
    */
		this.withRoutes()

		this.addDomEvents()

		this.lock = lock()

		// const $subnavOpener = document.querySelector('[data-show-subnav]')
		// $subnavOpener.addEventListener('click', this.onClickShow)

		// const $subnavCloser = document.querySelector('[data-hide-subnav]')
		// $subnavCloser.addEventListener('click', this.onClickHide)
	}

	mounted = () => {
		this.nav = new SponDraw({
			buttonActiveClass: 'menu-btn--active',
			openButton: '[data-menu-opener]',
			overlay: document.getElementById('site-menu'),
			contents: false,
			closeButton: '[data-menu-closer]'
		})

		const vp = resizer()
		vp.start()
		vp.at('(max-width: 64em)', {
			match: () => {
				this.enable()
			},
			unmatch: () => {
				this.disable()
			}
		})

		this.current = undefined
		this.$menuContainer = document.getElementById('menu-container')
		this.$closer = document.getElementById('menu-sub-nav-closer')
		this.$closerText = this.$closer.querySelector('.menu__closer__text')

		this.isRunning = false
		this.menuLevel = 1

		this.nav.on('open', ({ dom }) => {
			this.lock.capture()
		})

		this.nav.on('close', ({ dom }) => {
			this.lock.release()
		})

		this.animateSubItems()
	}

	// onChange = ({ from, to }) => {
	// 	if (from.name === to.name || to.name === 'fallback' || to.name === 'home') {
	// 		this.updateLevel(from, to)
	// 	} else {
	// 		this.fetchNav(from, to)
	// 	}
	// }

	onReady = ({ from, to, newPageRawHTML }) => {
		if (from.name === to.name || to.name === 'fallback') {
			this.updateLevel(from, to)
		} else {
			this.fetchNav(to, newPageRawHTML)
		}

		if (this.nav.isVisible) this.nav.close()
	}

	events = {
		'click [data-show-subnav]': 'onClickShow',
		'click [data-hide-subnav]': 'onClickHide'
	}

	updateLevel = (from, to) => {
		if (to.segments.length > 2) return false

		const { hasChildren } = from.linkClicked.dataset
		if (hasChildren) {
			this.$el.dataset.level = Number(this.$el.dataset.level) + 1
			from.linkClicked.parentNode
				.querySelector('.menu__dd')
				.classList.add('is-visible')
			this.animateSubItems()
		} else {
			this.$el.dataset.level = 1
		}
	}

	fetchNav = (to, newPageRawHTML) => {
		const $oldMenuContainer = document.getElementById('site-menu')
		const $newMenuContainer = domify(newPageRawHTML).querySelector(
			'#site-menu'
		).innerHTML

		// log('segments', to.segments.length)
		if (to.segments.length > 2) {
			this.$el.dataset.level = 2
		} else if (to.name === 'home') {
			this.$el.dataset.level = 0
		} else {
			this.$el.dataset.level = 1
		}

		// this.$el.dataset.level = Number(to.segments.length)

		this.currentNavHeight = $oldMenuContainer.clientHeight

		// ;[...document.querySelectorAll('.header__logo--school')].forEach((activeSchool) => {
		// 	activeSchool.classList.add('opacity-0')
		// })
		
		// const $schoolName = document.querySelector(`.header__logo-school--${sectionName}`)
		// const schoolTextName = {
		// 	home: 'Salisbury',
		// 	nursery: 'Prep',
		// 	senior: 'Senior',
		// 	sixthform: 'Sixth',
		// 	schoollife: 'School Life',
		// 	community: 'Community',
		// 	admissions: 'Admissions'
		// }

		anime({
			targets: [$oldMenuContainer],
			opacity: [1, 0],
			duration: 300,
			elasticity: 0,
			easing: 'easeInOutCubic',
			complete() {
				if ($oldMenuContainer.firstChild) {
					while ($oldMenuContainer.firstChild) {
						$oldMenuContainer.removeChild($oldMenuContainer.firstChild)
					}
				}

	
				// $schoolName.textContent = ''

				$('.menu__dd.is-visible').removeClass('opacity-0')

				// if($schoolName) $schoolName.classList.remove('is-active')

				anime({
					targets: [$oldMenuContainer],
					opacity: [0, 1],
					duration: 300,
					elasticity: 0,
					easing: 'easeInOutCubic',
					begin() {
						$oldMenuContainer.append(domify($newMenuContainer))
					}
				})
			}
		})

		if (this.events) {
			this.removeDomEvents()
		}

		this.addDomEvents()
	}

	/**
	 * Enable the mobile menu, bind click events
	 *
	 * @function enable
	 * @return Void
	 */
	enable = () => {
		this.nav.init()
	}

	/**
	 * Disable the mobile menu, remove click events
	 *
	 * @function disable
	 * @return Void
	 */
	disable = () => {
		this.nav.destroy()
		this.lock.release()
	}

	/**
	 * On click reveal the sub menu
	 *
	 * @function onClickShow
	 * @param {Object} event object
	 * @param {HTMLElement} dom node clicked
	 * @return Void
	 */
	onClickShow = (event, element) => {
		event.preventDefault()

		if (this.isRunning) return
		this.isRunning = true

		this.current = element.nextElementSibling
		this.openSubNav(element)

		// Check current nav height and update if needed, else return
		if (this.currentNavHeight > this.current.clientHeight) return

		this.$menuContainer.style.height = `${this.current.clientHeight}px`
		this.currentNavHeight = this.current.clientHeight
	}

	/**
	 * Hide the sub menu
	 *
	 * @function onClickHide
	 * @param {Object} event object
	 * @return Void
	 */
	onClickHide = event => {
		event.preventDefault()

		if (this.isRunning) return
		this.isRunning = true

		this.closeSubNav()
	}

	/**
	 * Open sub menu method
	 *
	 * @return Void
	 */
	openSubNav = () => {
		const level = Number(this.$el.dataset.level) + 1
		this.$el.dataset.level = level
		this.isRunning = false
		this.current.classList.add('is-visible')
		this.$closer.classList.add('is-visible')
		this.$closerText.textContent =
			level === 1
				? 'Back to Home'
				: 'Back to ' + this.$menuContainer.dataset.section

		this.animateSubItems()
	}

	/**
	 * Close sub menu method
	 *
	 * @return Void
	 */
	closeSubNav = () => {
		const level = Number(this.$el.dataset.level) - 1
		this.$el.dataset.level = level
		if (this.current) this.current.classList.remove('is-visible')
		if (this.$closer) this.$closer.classList.remove('is-visible')
		if (level === 2)
			$('[data-level3] > .menu__dd.is-visible').removeClass('is-visible')
		if (level === 1)
			$('[data-level2] > .menu__dd.is-visible').removeClass('is-visible')
		if (level === 0)
			$('[data-level1] > .menu__dd.is-visible').removeClass('is-visible')
		this.$closerText.textContent =
			level === 1
				? 'Back to Home'
				: 'Back to ' + this.$menuContainer.dataset.section
		this.isRunning = false
	}

	animateSubItems = () => {
		const $menuItems = [
			...this.$el.querySelectorAll('.menu__dd.is-visible .menu__item--lv2')
		]

		const tl = anime.timeline({
			autoplay: true,
			loop: false,
			direction: 'forwards'
		})

		$menuItems.forEach($item => {
			tl.add({
				targets: $item,
				opacity: [0, 1],
				translateY: ['10px', 0],
				duration: 200,
				elasticity: 0,
				easing: 'easeInOutCubic',
				autoplay: false,
				offset: `-=${150}`
			})
		})

		return tl
	}
}
